import isNil from 'lodash/isNil';
import isNaN from 'lodash/isNaN';
import isFunction from 'lodash/isFunction';
import { LOCALE, fullDateFormat, todayTimeFormat } from '@Constants/Localization';

function _insertCommas(integerStr) {
  const isNegative = integerStr.startsWith('-');
  const digits = isNegative ? integerStr.slice(1) : integerStr;
  let result = '';
  const len = digits.length;
  for (let i = 0; i < len; i += 1) {
    if (i > 0 && (len - i) % 3 === 0) {
      result += ',';
    }
    result += digits[i];
  }
  return isNegative ? `-${result}` : result;
}

export function commaFormatNumber(num) {
  // Prevent error
  if (!isFunction(num?.toString)) {
    return '';
  }
  const str = num?.toString() ?? '';
  const parts = str.split('.');
  parts[0] = _insertCommas(parts[0]);
  return parts.join('.');
}

function _roundTo(number, fractionSize) {
  // Or +(Math.round(number + `e+${fractionSize}`) + `e-${fractionSize}`);
  return parseFloat(number)?.toFixed(fractionSize);
}

export function formatNumberWithPostfix(number, extraSpace = false, fractionSize = 1) {
  if (number >= 1000 && number < 1000000) {
    // eslint-disable-next-line prefer-template
    return _roundTo(number / 1000, fractionSize) + `${extraSpace ? ' ' : ''}K`;
  }
  if (number >= 1000000) {
    // eslint-disable-next-line prefer-template
    return _roundTo(number / 1000000, fractionSize) + `${extraSpace ? ' ' : ''}M`;
  }
  return commaFormatNumber(number);
}

export function formatTodayDate(timestamp) {
  if (isNil(timestamp)) {
    return null;
  }

  const tsDate = new Date(timestamp);
  const cDate = new Date();
  const todayTimeFormatter = new Intl.DateTimeFormat(LOCALE, todayTimeFormat);
  const fullDateFormatter = new Intl.DateTimeFormat(LOCALE, fullDateFormat);

  if (fullDateFormatter.format(cDate) === fullDateFormatter.format(tsDate)) {
    return `Today ${todayTimeFormatter.format(tsDate)}`;
  }
  return fullDateFormatter.format(tsDate);
}

export function formatAlertsDate(inputDate) {
  if (isNil(inputDate)) {
    return null;
  }

  const date = new Date(inputDate);
  return new Intl.DateTimeFormat(LOCALE, fullDateFormat).format(date);
}

export function replaceCitations(input, isLongName) {
  return input
    ?.replace(/citation/gi, 'document')
    .replace(/SynthesisPlan/gi, 'reactions')
    .replace(/Tgitems/gi, isLongName ? 'Substances and Bioactivities' : 'Targets');
}

export function capitalize(input) {
  // eslint-disable-next-line prefer-template
  return input && input.replace(/(?:^\w|[A-Z])/g, (letter, index) => (index === 0 ? letter.toUpperCase() : ' ' + letter));
}

export function createE2EClass(input, isAddPrefix) {
  const result = input?.replace(/\W+/g, '-').toLowerCase();
  // eslint-disable-next-line prefer-template
  return input && isAddPrefix ? 'e2e-' + result : result;
}

export function addUrlProtocol(input) {
  // eslint-disable-next-line prefer-template,sonarjs/no-clear-text-protocols
  return input.indexOf('http') === 0 ? input : 'http://' + input;
}

export function concatLowerCase(input) {
  return input?.replace(/\W+/g, '').toLowerCase();
}

export function truncateSplitCharacters(input, chars) {
  if (isNaN(chars)) {
    return input;
  }
  if (chars <= 0) {
    return '';
  }
  if (input && input.length > chars) {
    const prefix = input.substring(0, chars / 2);
    const postfix = input.substring(input.length - chars / 2, input.length);
    return `${prefix}...${postfix}`;
  }
  return input;
}
